import SectionHeading from '@/pages/home/components/SectionHeading';
import { safetyTips } from '@/mocks/home';

export default function SafetyTips() {
  return (
    <section id="safety" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="安全提示"
          title="浏览入口时的六个注意事项"
          desc="入口信息整理得再清楚，也需要配合基本的安全习惯。下面这些提醒主要围绕来源判断与信息保护，帮助你降低误入仿冒页面的风险。"
          align="center"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {safetyTips.map((t, idx) => (
            <article
              key={t.title}
              className={`rounded-lg p-6 border h-full ${
                idx === 0 ? 'bg-accent-50 border-accent-200' : 'bg-background-100 border-background-200/70'
              }`}
            >
              <div
                className={`w-11 h-11 flex items-center justify-center rounded-lg ${
                  idx === 0 ? 'bg-accent-500 text-background-50' : 'bg-primary-100 text-primary-700'
                }`}
              >
                <i className={`${t.icon} text-xl`}></i>
              </div>
              <h3 className="mt-4 text-base font-semibold text-foreground-950">{t.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{t.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}